import { useQueries } from '@tanstack/react-query'
import { getProfileAsync } from '@/modules/PetSitter/viewProfileServiceHelper'
import { useNotifications } from '@/modules/Notifications'

import { useNewRequestCartStore } from '@/store/newRequestCartStore'

// usePetsittersQueries.ts (React Query v4/v5 compatible)
export const usePetsittersQueries = (petsitterIds: string[]) => {
  const [addNotificationError] = useNotifications()
  const removePetsitter = useNewRequestCartStore((s) => s.removePetsitter)

  return useQueries({
    queries: petsitterIds.map((id) => ({
      queryKey: ['petsitter', id],
      queryFn: () => getProfileAsync(id),
      staleTime: Infinity,
      // v5: gcTime, v4: cacheTime — use whichever your version supports
      cacheTime: 30 * 60 * 1000,
      // Optional: retry only for 5xx/timeouts, not for 4xx
      retry: (failureCount, error: any) => {
        const s = error?.status
        if (s >= 400 && s < 500) return false
        return failureCount < 2
      },
      onError: async (error: any) => {
        addNotificationError({ error })
        const status = error?.status
        if (status === 404 || status === 410) {
          // Only then do we purge the ID
          await removePetsitter(id)
        }
        // For anything else (0, 401, 429, 5xx…), DO NOT mutate the cart.
      },
    })),
  })
}
